import Vue from 'vue';
import moment from 'moment';
Vue.filter('capitalize', function (val) {
  return val.toUpperCase();
});
Vue.filter('DateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm:ss');
  }
});
Vue.filter('Date', function (value) {
  if (value === '0000-00-00') {
    return '-';
  }
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});
Vue.filter('Currency', function (value) {
  if (value) {
    if (value === '') {
      return value;
    }
    return floatWithCommas(value);
  } else {
    return floatWithCommas(0);
  }
});
Vue.filter('Number', function (value) {
  if (value !== '' && value != null) {
    if (value === '') {
      return value;
    }
    return numberWithCommas(value);
  } else {
    return '0';
  }
});
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function floatWithCommas(x) {
  var value = parseFloat(x).toFixed(2).toLocaleString();

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}


//////////////////
// WEBPACK FOOTER
// ./plugins/filters.js
// module id = ./plugins/filters.js
// module chunks = 82